import { render, staticRenderFns } from "./StudentNameSearch.vue?vue&type=template&id=5bf125e0&scoped=true"
import script from "./StudentNameSearch.vue?vue&type=script&lang=js"
export * from "./StudentNameSearch.vue?vue&type=script&lang=js"
import style0 from "./StudentNameSearch.vue?vue&type=style&index=0&id=5bf125e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf125e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VImg,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
